import { GetSustainabilityTotalEmissionsRequestParams } from '@/hooks'
import { SustainabilityFiltersValues } from '@/utils/constants'

export const mapSustainabilityParamsToFilters = (
    filters: GetSustainabilityTotalEmissionsRequestParams
) => {
    const mapped: SustainabilityFiltersValues = {
        node: filters['nodeIds[]']
            ? filters['nodeIds[]'].split(',').map((id) => Number(id))
            : [],
        commodity: filters['commodityTypeIds[]']
            ? filters['commodityTypeIds[]'].split(',').map((id) => Number(id))
            : [],
        contract: filters['contractIds[]']
            ? filters['contractIds[]'].split(',').map((id) => Number(id))
            : [],
        timeline: {
            type: 'isBetween',
            value: {
                startDate: filters.startDate ?? '',
                endDate: filters.endDate ?? '',
            },
        },
        tag: filters['tagIds[]']
            ? filters['tagIds[]'].split(',').map((id) => Number(id))
            : [],
        facility: filters['facilityIds[]']
            ? filters['facilityIds[]'].split(',').map((id) => Number(id))
            : [],
        meter: filters['meterIds[]']
            ? filters['meterIds[]'].split(',').map((id) => Number(id))
            : [],
    }

    return mapped
}
